import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import { componentUtils } from '@mtfe/sweet-components';
import tpl from './dom.html';
import style from './style.less';
import InnerPoi from '../common/InnerPoi/script';
import { renderPoiInfoGWithCoupon, renderPoiInfoH } from '../../utils/renderPoi';
import store from '../../store';
import RegularPoi from '../RegularPoi/script';

const { storeCommon } = store;
const { createUniqueId } = common;
const { getOnClickEventName } = componentUtils;

const CrazyPoiList = () => {
    const {
        dom_wm_big_coupon_left: domCrazyCoupon,
        dom_wm_big_coupon_none: domNoneCrazyCoupon,
        dom_wm_self_coupon: domWmSelfCouponAll,
    } = storeCommon.structInfo.struct;

    const storeCrazyCoupon = store[domCrazyCoupon.recallBizId];
    const storeNoneCrazyCoupon = store[domNoneCrazyCoupon.recallBizId];
    const storeWmSelfCouponAll = store[domWmSelfCouponAll.recallBizId];
    const showMoreId = createUniqueId();
    const noneCrazyId = createUniqueId();
    const selfCouponId = createUniqueId();

    let isOpenAutoLoading = true;
    const onEnding = () => {
        if (storeNoneCrazyCoupon.isShow) {
            const domShowMore = dom.$id(showMoreId);
            const selfCouponDom = dom.$id(selfCouponId);
            if (domShowMore) {
                domShowMore.style.display = 'flex';
            }
            if (selfCouponDom && storeWmSelfCouponAll.isShow) {
                selfCouponDom.style.display = 'flex';
                eventBus.$emit(getOnClickEventName(storeWmSelfCouponAll.recallBizId));
            }

            return { endText: '' };
        }
        return {};
    };

    if (!storeCrazyCoupon.isShow && storeNoneCrazyCoupon.isShow) {
        isOpenAutoLoading = false;
        storeCrazyCoupon.poiData.poiList = [storeNoneCrazyCoupon.poiData.poiList.shift()];
    }

    const poiContainerID = createUniqueId();
    const bottomTipID = createUniqueId();
    const selfAllDom = RegularPoi({
        poiData: storeWmSelfCouponAll.poiData,
        poiContainerID,
        renderFunc: renderPoiInfoGWithCoupon,
        bottomTipID,
    });
    const data = {
        crazyPoiList: InnerPoi({
            poiData: storeCrazyCoupon.poiData,
            renderFunc: renderPoiInfoH,
            isOpenAutoLoading,
            onEnding,
        }),
        noneCrazyPoiList: InnerPoi({
            poiData: storeNoneCrazyCoupon.poiData,
            renderFunc: renderPoiInfoH,
        }),
        selfCouponPoiList: selfAllDom,
        showMoreId,
        noneCrazyId,
        selfCouponId,
        poiContainerID,
        bottomTipID,
    };
    const events = {
        onClickShowMore: () => {
            const domShowMore = dom.$id(showMoreId);
            const domNoneCrazy = dom.$id(noneCrazyId);

            domShowMore.style.display = 'none';
            domNoneCrazy.style.display = 'block';
            eventBus.$emit(getOnClickEventName(storeNoneCrazyCoupon.recallBizId));
        },
    };
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default CrazyPoiList;
